module.exports = __webpack_public_path__ + "img/partners.dec2ba29.png";